let i18n = {
  'test' : 'testing...'
}
export default i18n;


// WEBPACK FOOTER //
// ./wp-content/plugins/instaberg/src/misc/i18n.js